import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";

// Import images in sequence order (10 → 1, then loop)
import transform10 from "@/assets/how-it-works/transform-10.jpg";
import transform09 from "@/assets/how-it-works/transform-09.jpg";
import transform08 from "@/assets/how-it-works/transform-08.jpg";
import transform07 from "@/assets/how-it-works/transform-07.jpg";
import transform06 from "@/assets/how-it-works/transform-06.jpg";
import transform05 from "@/assets/how-it-works/transform-05.jpg";
import transform04 from "@/assets/how-it-works/transform-04.jpg";
import transform03 from "@/assets/how-it-works/transform-03.jpg";
import transform02 from "@/assets/how-it-works/transform-02.jpg";
import transform01 from "@/assets/how-it-works/transform-01.jpg";

// Order: 10 → 9 → 8 → 7 → 6 → 5 → 4 → 3 → 2 → 1 → loop
const images = [
  { src: transform10, alt: "Barn på lekplats" },
  { src: transform09, alt: "Sagokaraktär i vinterskog" },
  { src: transform08, alt: "Flicka som ritar" },
  { src: transform07, alt: "Sagokaraktär i skogen" },
  { src: transform06, alt: "Pojke i rullstol" },
  { src: transform05, alt: "Sagokaraktär på museum" },
  { src: transform04, alt: "Barn vid julgranen" },
  { src: transform03, alt: "Sagokaraktär med enhörning" },
  { src: transform02, alt: "Flicka med rosett" },
  { src: transform01, alt: "Sagokaraktär på stranden" },
];

const PhotoToCharacterSlideshow = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 2000); // Change image every 2 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full h-full overflow-hidden">
      <AnimatePresence mode="sync">
        <motion.img
          key={currentIndex}
          src={images[currentIndex].src}
          alt={images[currentIndex].alt}
          className="absolute inset-0 w-full h-full object-cover"
          width={480}
          height={480}
          loading="lazy"
          decoding="async"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ 
            duration: 1.2, 
            ease: "easeInOut" 
          }}
        />
      </AnimatePresence>
    </div>
  );
};

export default PhotoToCharacterSlideshow;
